const toggleUserScalableMetaTag = (toggleToYes, metas) => {
  const yesOrNo = toggleToYes ? 'yes' : 'no';
  metas.forEach(m => {
    if (m.name === 'viewport' && m.content) {
      // toggle the user-scalable to yes or no
      const replaced = m.content.replace(
        `user-scalable=${(yesOrNo === 'no' ? 'yes' : 'no')}`,
        `user-scalable=${yesOrNo}`,
      );
      m.content = replaced;
    }
  });
};

export { toggleUserScalableMetaTag }; // eslint-disable-line
